import type { EditorContextType } from "@/components/app/editor-v3/editor-context";

export const GATED_CONTENT_REQUIRED_MESSAGE =
  "Add content to the Gated Content section before posting.";

export const hasRequiredGatedPayload = ({
  gatedBody,
  gatedMedia,
  poll,
}: Pick<EditorContextType, "gatedBody" | "gatedMedia" | "poll">) => {
  return gatedBody.trim().length > 0 || gatedMedia.length > 0 || Boolean(poll);
};

export const getGatedContentValidationError = (
  editorContext: EditorContextType,
) => {
  if (editorContext.gated() && !hasRequiredGatedPayload(editorContext)) {
    return GATED_CONTENT_REQUIRED_MESSAGE;
  }

  return null;
};

export const swapPreviewAndGatedContent = (
  editorContext: Pick<
    EditorContextType,
    "body" | "gatedBody" | "media" | "gatedMedia"
  >,
) => ({
  body: editorContext.gatedBody,
  gatedBody: editorContext.body,
  media: editorContext.gatedMedia,
  gatedMedia: editorContext.media,
});

export const hasSwappablePreviewOrGatedContent = (
  editorContext: Pick<
    EditorContextType,
    "body" | "gatedBody" | "media" | "gatedMedia"
  >,
) => {
  return (
    editorContext.body.trim().length > 0 ||
    editorContext.gatedBody.trim().length > 0 ||
    editorContext.media.length > 0 ||
    editorContext.gatedMedia.length > 0
  );
};
